import { useCallback, useSyncExternalStore } from "react";
import {
  clearSession,
  getUser,
  snapshot,
  subscribe,
  type SessionUser,
} from "./session";

export interface Session {
  user: SessionUser | null;
  isAuthenticated: boolean;
  can: (permission: string) => boolean;
  canAny: (permissions: string[]) => boolean;
  signOut: () => void;
}

export function useSession(): Session {
  const token = useSyncExternalStore(subscribe, snapshot, snapshot);
  const user = token ? getUser() : null;

  const can = useCallback(
    (permission: string) => user?.permissions.includes(permission) ?? false,
    [user],
  );

  const canAny = useCallback(
    (permissions: string[]) =>
      permissions.some((permission) => user?.permissions.includes(permission)),
    [user],
  );

  return {
    user,
    isAuthenticated: Boolean(token && user),
    can,
    canAny,
    signOut: clearSession,
  };
}
